import React from 'react';
import APIServicesRegistry from '../../api-services/APIServicesRegistry';
import LanguageApiService from '../../api-services/LanguageApiService';

const LanguageSwicher = class LanguageSwicher extends React.Component {

    constructor(props) {
        super(props);

        scheduleAtDocumentReady(() => {
            this.api = APIServicesRegistry.getService(LanguageApiService)
        })
    }

    render() {
        let {selectedLanguageId, languages} = this.props;

        return (
            <select className="language-swicher" value={selectedLanguageId}
                    onChange={e => this.onChange(e.target.value)}>
                {languages.map(x => this.renderOption(x))}
            </select>
        )
    }

    renderOption = language => (
        <option key={language.id} value={language.id}>
            {language.name}
        </option>
    )

    onChange = value => {
        this.api.setApplicationLanguage({
            languageId: value,
            redirectTo: this.props.redirectTo
        });
    }
}

window.components.LanguageSwicher = LanguageSwicher;
export default LanguageSwicher;